import { NavLink } from 'react-router';
import { useTranslation } from 'react-i18next';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { DriveOnDisplayableTaskDto as DriveonTask } from '@/generated/model';
import { Button } from '@mui/material';
import { useDriveOnContext } from '@/contexts/DriveOnContext';

import './Active.css';
import { ReactElement, useState } from 'react';
import { TaskDetailDialog } from '../logbook/task/TaskDetailDialog';
import { MapAppPicker } from '../common/MapAppPicker';

export function ActiveTask() {
  const { t } = useTranslation();
  const driveOnCtx = useDriveOnContext();
  const [dialog, setDialog] = useState<ReactElement | undefined>(undefined);
  const [gpsDialog, setGpsDialog] = useState<ReactElement | undefined>(undefined);


  function checkIfEmpty(label: string | undefined | 0): string {
    if (label) {
      return label;
    }
    return t('menetlevel.taskchooser.nodata');
  }
  
  function confirm(task: DriveonTask) {
    function onClose() {
      setDialog(undefined);
    }

    setDialog(<TaskDetailDialog onClose={onClose} task={task} checkIfEmpty={checkIfEmpty} />);
  }

  function showGpsDialog(task: DriveonTask) {
    function onClose() {
      setGpsDialog(undefined);
    }
  
    setGpsDialog(<MapAppPicker type={'gps'} task={task} onClose={onClose} />);
  }
  
  function isAdhocTask(): boolean {
    if (driveOnCtx.task?.eventusId.includes('adhoc')) {
      return true;
    }
    return false;
  }

  function Task({ task }: { task: DriveonTask }) {
    return (
      <>
        {!isAdhocTask() && <div>{task.eventusId}</div>}
        <div>{task.taskName}</div>
        <div className="button-container">
          <Button className="button" variant="contained" onClick={() => confirm(task)}>{t('home.activetask.details')}</Button>
          <Button className="button" variant="contained" onClick={() => showGpsDialog(task)}>Navigáció</Button>
        </div>
      </>
    );
  }

  function NoTask() {
    return (
      <>
        <div>{t('home.activetask.notask')}</div>
        <div className="button-container">
          <NavLink className="link" to="/menetlevel/feladatvalaszto">
            <Button variant="contained" className="button">{t('home.activetask.choose')}</Button>
          </NavLink>
        </div>
      </>
    );
  }

  return (
    <div className="active">
      <div className="title">
        <ListAltIcon className="icon" />
        <span>{t('home.activetask.title')}</span>
      </div>
      {driveOnCtx.task ? <Task task={driveOnCtx.task} /> : <NoTask />}
      {dialog}
      {gpsDialog}
    </div>
  );
}
